export default __webpack_public_path__ + "static/butter-yellow-banner-desktop-f5f27eedaa17c8ec0815d2464b32a2ae.webp";